<template>
  <div class="settings-module-root">
    <ba-header activeModule="Global Settings" disable-menu="true">

  </ba-header>
    <ba-page-with-sidebar :title="'Global Settings'">
      <template slot="main" >
        <h3 class="u-pt5 c-heading__page u-pb3" v-loading="loading">Global Settings</h3>
        <div class="el-card setting-section u-mt4 u-pb0">
          <h3 class="u-mb3">Standard Settings</h3>
          <ba-single-setting v-for="setting in standardSettings" :key="setting.id" :setting="setting" :isGlobal="true">
          </ba-single-setting>
          <h3 class="u-mb3 u-mt4">AWS Settings</h3>
          <ba-single-setting v-for="setting in awsSettings" :key="setting.id" :setting="setting" :isGlobal="true">
          </ba-single-setting>
          <el-button class="u-mb4" @click="updateTranslations()">Update Custom Translations</el-button>
        </div>
      </template>
    </ba-page-with-sidebar>
  </div>
</template>

<script>
  import axios from 'axios'
  import config from '@/config'
  import {mapActions, mapState} from 'vuex'
  import BaPageWithSidebar from '@/components/page-with-sidebar.component'
  import BaSingleSetting from '@/modules/settings/single-setting.component'

  export default {
    components: {
      BaPageWithSidebar,
      BaSingleSetting,
    },
    methods: {
      ...mapActions('globalSettings', ['load']),
      updateTranslations () {
        axios.get(`${config.url}/update_custom_translation/`)
          .then(response => {
            this.$notify({
              title: 'Success',
              message: 'Translations updated',
              type: 'success'
            })
          })
          .catch(response => {
            this.$alert('There was an error updating the translations')
          })
      },
      filtered (filterFunction) {
        let settings = []
        if (!this.loading) {
          this.all.forEach((setting) => {
            if (filterFunction(setting)) {
              settings.push(setting)
            }
          })
        }
        return settings
      },
    },
    computed: {
      ...mapState('globalSettings', ['all']),
      awsSettings () {
        return this.filtered(setting => setting.name.includes('AWS'))
      },
      standardSettings () {
        return this.filtered(setting => !setting.name.includes('AWS'))
      },
    },
    data () {
      let loading = true
      this.load().then(() => {
        this.loading = false
      }, () => {
        this.loading = false
        this.$message('Settings is not found. Please reload page')
      })
      return {
        loading,
      }
    },
  }
</script>
<style>

</style>
